<template>
  <div id="pageContent">
    <div id="formArea" class="borderBox">
        <h1> Добро пожаловать!</h1>
        <p>Вы авторизовались как {{getProfile.displayname}}</p>
    </div>
  </div>
</template>

<script>

  import {mapGetters, mapState} from 'vuex'
export default {
  name: 'home',
  components: {},
  methods:{
    loadOperatorScript:function () {
      if (this.getIncomeScripts.length == 0) {
        this.$myApi.scriptContent()
        .then((result)=>{
          this.$store.dispatch('setScripts',result)})
        .catch((msg)=>{console.log(msg)});
      }
    }
  },
  computed:{
    ...mapGetters(['getIncomeScripts','getProfile']),
  },
  mounted: function () {
    this.loadOperatorScript();
  }
}
</script>

<style scoped>
  #formArea{width: 900px;}
  @media screen and (max-width: 1600px){
    #pageContent{position: absolute;height: auto;}
  }
</style>
